import type { ChangeEvent } from "react";
import TextField from "@mui/material/TextField";
import { when } from "util/support";
import { getFormInputProps } from "util/forms";
import { FormField } from "../../types";
import type { NumberValue, SetupValueProps } from "../types";

const Int = ({
    values,
    handleBlur,
    onChange,
    ...restProps
}: SetupValueProps<NumberValue>) => (
    <TextField
        {...getFormInputProps(FormField.SetupValue, restProps)}
        fullWidth
        type='number'
        size='small'
        name={FormField.SetupValue}
        value={values[FormField.SetupValue].value}
        label='Number Setup Value'
        onBlur={handleBlur}
        onChange={({ target }: ChangeEvent<HTMLInputElement>) => onChange!(
            when(
                target.value.length,
                () => Number(target.value),
                target.value
            )
        )}
    />
);

export default Int;